
import env from '~/mixins/env'

export default {
  mixins: [env],
}
